import React from "react";
import useCommandFlowStore from "../store/commandFlowStore";

const TerminalOutput = ({ theme, terminalTextStyle }) => {
  const output = useCommandFlowStore((state) => state.output);
  const frameMode = useCommandFlowStore((state) => state.frameMode);
  const frameStartIndex = useCommandFlowStore((state) => state.frameStartIndex);

  const visibleOutput = frameMode ? output.slice(frameStartIndex) : output;

  return (
    <>
      {visibleOutput.map((line, idx) => {
        if (line == null) return null;
        const stableKey = frameMode ? frameStartIndex + idx : idx;
        let segments = [];
        let type = "output";

        if (Array.isArray(line)) {
          segments = line;
        } else if (typeof line === "object" && Array.isArray(line.text)) {
          segments = line.text;
          type = line.type || "output";
        } else if (typeof line === "object" && typeof line.text === "string") {
          segments = [{ text: line.text, color: null }];
          type = line.type || "output";
        } else if (typeof line === "string") {
          segments = [{ text: line, color: null }];
        }

        // If segments is an array of colored segments, render inline
        if (segments.length > 1 || (segments[0] && segments[0].color)) {
          return (
            <div
              key={stableKey}
              style={{ whiteSpace: "pre-wrap", ...terminalTextStyle }}
            >
              {segments.map((seg, i) => {
                let color;
                if (seg.color === "prompt") color = theme.promptColor;
                else if (seg.color === "input") color = theme.color;
                else if (seg.color === "output") color = theme.successColor;
                else if (seg.color === "success") color = theme.successColor;
                else if (seg.color === "error") color = theme.errorColor;
                else if (seg.color === "warn" || seg.color === "warning")
                  color = theme.warningColor;
                else if (seg.color === "title")
                  color = theme.titleColor || theme.color;
                else if (seg.color === "value" || seg.color === "accent")
                  color = theme.accentColor || theme.color;
                else if (seg.color === "muted")
                  color = theme.mutedColor || "rgba(255, 255, 255, 0.6)";
                else if (typeof seg.color === "string" && seg.color)
                  color = seg.color; // pass-through hex / CSS color
                else if (type === "input") color = theme.color;
                else if (type === "output") color = theme.successColor;
                else color = theme.successColor;

                const spanStyle = { color };
                if (seg.bg) {
                  spanStyle.backgroundColor = seg.bg;
                  spanStyle.borderRadius = "3px";
                  spanStyle.padding = "1px 4px";
                }

                return (
                  <span key={i} style={spanStyle}>
                    {seg.text}
                  </span>
                );
              })}
            </div>
          );
        }

        // Fallback: just render as before
        let fallbackColor = theme.successColor;
        if (type === "input") fallbackColor = theme.color;
        if (type === "output") fallbackColor = theme.successColor;

        return (
          <div
            key={stableKey}
            style={{
              whiteSpace: "pre-wrap",
              ...terminalTextStyle,
              color: fallbackColor,
            }}
          >
            {segments[0] ? segments[0].text : ""}
          </div>
        );
      })}
    </>
  );
};

export default TerminalOutput;
